import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ElementType } from 'react';

export interface ListSecondaryTextIconProps {
  label: string;
  variant?: 'primary' | 'secondary';
  icon: ElementType;
}

export const ListSecondaryTextIcon = ({ label, variant, icon: Icon }: ListSecondaryTextIconProps) => (
  <Stack
    direction="row"
    component="span"
    sx={{
      alignItems: 'center',
    }}
  >
    <Icon fontSize="inherit" color={variant === 'primary' ? 'action' : 'error'} />
    <Box
      component="span"
      sx={{
        ml: 0.5,
      }}
    >
      <Typography component="span" color={variant === 'primary' ? 'text.primary' : 'error'}>
        {label}
      </Typography>
    </Box>
  </Stack>
);
